import DashboardPage from "./dashboard-page";

export default DashboardPage